import {EntityWithId} from "../baseEntities";

export enum ActivityFields {
    ActivityTypeCode = 'tinCodActividadTipo',
    MotiveCode = 'sinCodMotivo',
    MotiveTypeCode = 'sinCodMotivoTipo',
    AssignedGroupId = 'intIdGrupoAsignado',
    AllocatorGroupId = 'intIdGrupoAsignador',
    ActivityDate = 'dtmFecha',
    ExpirationDate = 'dtmFechaVencimiento',
    BeginDate = 'dtmFechaAlta',
    RegisterUserId = 'intIdUsuarioAlta',
    ActivityStateCode = 'tinCodActividadEstado',
    ActivityStateClassificationCode = 'tinCodActividadEstadoClasificacion',
    StateDate = 'dtmFechaEstado',
    StateUserId = 'intIdUsuarioEstado',
    Reference = 'vchReferencia',
    Observations = 'vchObservacion',
    ResponsibleUserId = 'intIdUsuarioResponsable',
    ActivityTrackingCode = 'tinCodActividadSeguimiento',
    HasPriority = 'bitConPrioridad',

    ActivityTypeDesc = 'vchDescActividadTipo',
    ActivityStateDesc = 'vchDescActividadEstado',
    ActivityStateClassificationDesc = 'vchDescActividadEstadoClasificacion',
    ActivityTrackingDesc = 'vchDescActividadSeguimiento',
    MotiveDesc = 'vchDescMotivo',
    MotiveTypeDesc = 'vchDescMotivoTipo',
    AssignedGroupDesc = 'vchDescGrupoAsignado',
    AllocatorGroupDesc = 'vchDescGrupoAsignador',
    RegisterUserDesc = 'vchDescUsuarioAlta',
    ResponsibleUserDesc = 'vchDescUsuarioResponsable',
    IsTracked = 'bitTieneSeguimiento',
}

export interface Activity extends EntityWithId<number> {
    [ActivityFields.ActivityTypeCode]: number;
    [ActivityFields.MotiveCode]: number;
    [ActivityFields.MotiveTypeCode]: number;
    [ActivityFields.AssignedGroupId]: number;
    [ActivityFields.AllocatorGroupId]: number;
    [ActivityFields.ActivityDate]: Date;
    [ActivityFields.ExpirationDate]?: Date;
    [ActivityFields.BeginDate]: Date;
    [ActivityFields.RegisterUserId]: number;
    [ActivityFields.ActivityStateCode]: number;
    [ActivityFields.ActivityStateClassificationCode]: number;
    [ActivityFields.StateDate]: Date;
    [ActivityFields.StateUserId]: number;
    [ActivityFields.Reference]: string;
    [ActivityFields.Observations]: string;
    [ActivityFields.ResponsibleUserId]?: number;
    [ActivityFields.ActivityTrackingCode]: number;
    [ActivityFields.HasPriority]: boolean;

    [ActivityFields.ActivityTypeDesc]: string;
    [ActivityFields.ActivityStateDesc]: string;
    [ActivityFields.ActivityStateClassificationDesc]: string;
    [ActivityFields.ActivityTrackingDesc]: string;
    [ActivityFields.MotiveDesc]: string;
    [ActivityFields.MotiveTypeDesc]: string;
    [ActivityFields.AssignedGroupDesc]: string;
    [ActivityFields.AllocatorGroupDesc]: string;
    [ActivityFields.RegisterUserDesc]: string;
    [ActivityFields.ResponsibleUserDesc]: string;
    [ActivityFields.IsTracked]: boolean;
}

export enum ActivitySolicitationFields {
    SolicitationId = 'intIdSolicitud',
}

export interface ActivitySolicitation extends Activity {
    [ActivitySolicitationFields.SolicitationId]: number
}

export enum ActivityOnboardingCompleteFields {
    SolicitationId = 'idSolicitud',
    Observation = 'observacion'
}

export interface ActivityOnboardingComplete {
    [ActivityOnboardingCompleteFields.SolicitationId]: number;
    [ActivityOnboardingCompleteFields.Observation]: string
}

export interface ActivityStatusStory extends EntityWithId<number> {
    intIdActividad: number,
    tinCodActividadEstado: number,
    dtmFechaEstado: Date,
    intIdUsuarioEstado: number,
    vchObservacionEstado: string,
    vchDescUsuarioEstado: string,
    vchDescActividadEstado: string,
}